import React from 'react';
import PropTypes from 'prop-types';
import { Modal as BaseModal, Button } from 'react-bootstrap';

import Spinner from 'components/Admin/Templates/Widgets/Spinner';
import useTemplate from 'components/Common/Templates/Hooks/useTemplate';

import Details from './Details';

export default function Modal({ row, show, onHide }) {
  const template = useTemplate(row.id);

  return (
    <BaseModal
      className="student inmodal auto without-overflow"
      show={show}
      onHide={onHide}
    >
      <BaseModal.Header closeButton>
        <BaseModal.Title>Program Details</BaseModal.Title>
      </BaseModal.Header>

      <BaseModal.Body>
        {template ? (
          <>
            <Details template={template} />

            <footer className="text-center mt20">
              <Button
                bsStyle="primary"
                className="btn-outline width-120 mr10"
                onClick={onHide}
              >
                Close
              </Button>
            </footer>
          </>
        ) : (
          <Spinner />
        )}
      </BaseModal.Body>
    </BaseModal>
  );
}

Modal.propTypes = {
  row: PropTypes.object.isRequired,
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
};
